module.exports = __webpack_public_path__ + "img/service_cloud_6_2x.cfae6194.jpg";